<template>
<div class="chapter">
<div class="inner_page">
<p class="cpytxt1"><span><a id="page_iv"></a>M<span class="small">ASTER OF</span> S<span class="small">PACE AND</span> T<span class="small">IME</span></span></p>
<p class="cpytxt"><span>Published by<br/>Thunder’s Mouth Press<br/>An Imprint of Avalon Publishing Group Inc.<br/>245 West 17th St., 11th Floor<br/>New York, NY 10011</span></p>
<p class="image"><span><img alt="Image" src="images/copy.jpg"/></span></p>
<p class="cpytxt"><span>Copyright © 1984 by Rudy Rucker</span></p>
<p class="cpytxt"><span>First Thunder’s Mouth Press edition April 2005</span></p>
<p class="cpytxt"><span>All rights reserved. No part of this publication may be reproduced<br/>or transmitted in any form or by any means, electronic or mechanical,<br/>including photocopy, recording, or any information storage and retrieval<br/>system now known or to be invented, without permission in writing<br/>from the publisher, except by a reviewer who wishes to quote brief<br/>passages in connection with a review written for inclusion in a<br/>magazine, newspaper or broadcast.</span></p>
<p class="cpytxt"><span>Library of Congress Cataloging-in-Publication Data is available.</span></p>
<p class="cpytxt"><span>ISBN 1-56025-703-2</span></p>
<p class="cpytxt"><span>10  9  8  7  6  5  4  3  2  1</span></p>
<p class="cpytxt"><span>Book design by Terry McCabe<br/>Distributed by Publishers Group West</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?533cb710